module.exports = __webpack_public_path__ + "img/not-used.8140d500.svg";